<template>
  <div class="wrapper" v-if="isArticleReady">
    <div class="container-area ">
      <bannerTitle></bannerTitle>
      <img v-if="articles[articleId - 1].coverPicture" class="top-banner-picture"
        :src="resolveAsset(articles[articleId - 1].coverPicture)">

      <div class="content-head">
        <h2 class="content-title">{{ articles[articleId - 1].title }}</h2><br>
        <h4 class="content-author">{{ articles[articleId - 1].author }}</h4><br>
        <div v-if="articles[articleId - 1].audio && resolveAudio(articles[articleId - 1].audio)">
          <audio controls autoplay>
            <source :src="resolveAudio(articles[articleId - 1].audio)" type="audio/mp4">
            <source :src="resolveAudio(articles[articleId - 1].audio)" type="audio/wav">
            <source :src="resolveAudio(articles[articleId - 1].audio)" type="audio/m4a">
            <source :src="resolveAudio(articles[articleId - 1].audio)" type="audio/aac">
            <source :src="resolveAudio(articles[articleId - 1].audio)" type="audio/mpeg">
            Your browser does not support the audio element.
          </audio>
        </div>
        <div v-if="articles[articleId - 1].audioAuthor">
          <a style="color:gray">發音人：{{ articles[articleId - 1].audioAuthor }}</a>
        </div>
      </div>
      <div v-for="(contentobj, index) in articles[articleId - 1].content" :key="index">
        <div class="content-text" v-if="contentobj.type === 'text'">
          <span v-for="(subContent, subIndex) in contentobj.content" :key="subIndex">
            <span class="preserve-whitespace" v-if="subContent.type == 'text'"> {{ subContent.content }}</span>
            <span class="preserve-whitespace" v-if="subContent.type == 'hashTag'"> <strong>{{ subContent.content }}</strong></span>
            <a v-if="subContent.type == 'link'" :href="subContent.content" target="_blank">{{ subContent.content }}</a>
            <a v-if="subContent.type == 'email'" :href="'mailto:'+subContent.content">{{ subContent.content }}</a>
          </span>
        </div>
        <div class="mb-3" v-else-if="contentobj.type === 'image'">
          <img class="content-img" :src="resolveAsset(contentobj.content)">
        </div>
        <div class="content-text" v-else-if="contentobj.type === 'caption'">{{ contentobj.content }}</div>
        <div class="content-text" v-else-if="contentobj.type === 'captionStrong'"><strong>{{ contentobj.content }}</strong></div>
        <div class="mb-3" v-else-if="contentobj.type === 'video'">
          <video width="640" height="480" controls>
            <source :src="resolveAsset(contentobj.content)" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <backToFP></backToFP>
      <bannerBottom></bannerBottom>
    </div>
  </div>
</template>

<script>
import { parsingFunctionMixin } from '@/components/parsingFunction.js'
import { toRaw } from 'vue'
import bannerTitle from '@/components/banner.vue'
import backToFP from '@/components/backBtn.vue'
import bannerBottom from '@/components/bannerBottom.vue'
export default {
  name: 'ContentPage',
  components: {
    bannerTitle,
    backToFP,
    bannerBottom
  },
  computed: {
    articleId() {
      return this.$route.params.subId;
    },
    isArticleReady() {
      return this.articles[this.articleId - 1]?.coverPicture != null;
    },

  },
  watch: {
    articles: {
      handler(newVal) {
        const rawArticles = toRaw(newVal); // 這是Vue3 articles被判定成Proxy的物件時，要先轉型成原始物件，不然直接.length會得到0
        if (Array.isArray(rawArticles) && rawArticles.length > 0) {
          this.checkArticles();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mixins: [parsingFunctionMixin],
  methods: {
    checkArticles() {
      if (this.articleId > this.articles.length) {
        this.$router.push('/')
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置
    from.meta.savedPosition = window.scrollY;
    next();
  },
}
</script>

<!-- Add "scoped" attribute to limit aCSS to this component only -->
<style scoped>
.content-text {
  text-align: left;
  text-indent: 2em;
  margin: 10px 24px;
  min-height: 20px;
}

.content-head {
  margin-top: 30px;
}

.content-title {
  font-weight: bold;
  font-size: 24px;
  color: #be369b;
}

.content-author {
  font-weight: bold;
  font-size: 16px;
}

.content-img {
  height: auto;
  margin: 0 auto 0em;
  display: block;
  width: 65%;
}

.preserve-whitespace {
  white-space: pre-wrap;
}
</style>
